/**
 * Contact page inquiry prefill from Vertical Tabs URL params.
 * Example:
 * /pages/contact-us?type=team&type_label=I'm%20a%20Team&size=2-15&size_label=2-15&size_name=Team%20Size
 */
(function () {
  if (window.__contactInquiryBound) return;
  window.__contactInquiryBound = true;

  const SKIP_KEYS = new Set(['type', 'type_label']);

  function readParams() {
    const params = new URLSearchParams(window.location.search);
    const entries = [];

    const type = params.get('type');
    const typeLabel = params.get('type_label') || type;
    if (type || typeLabel) {
      entries.push({ key: 'type', name: 'Customer type', value: typeLabel || type });
    }

    for (const [key, value] of params.entries()) {
      if (SKIP_KEYS.has(key) || key.endsWith('_label') || key.endsWith('_name')) continue;
      const name = params.get(`${key}_name`) || key;
      const label = params.get(`${key}_label`) || value;
      entries.push({ key, name, value: label });
    }

    return entries;
  }

  function buildMessage(entries) {
    const lines = entries.map((item) => `${item.name}: ${item.value}`);
    lines.push('Additional notes:');
    lines.push('');
    return lines.join('\n');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildSummaryHtml(entries) {
    const items = entries
      .map(
        (item) =>
          `<li><strong>${escapeHtml(item.name)}:</strong> ${escapeHtml(item.value)}</li>`
      )
      .join('');
    return `
      <p class="contact-inquiry-summary__title">Your inquiry profile</p>
      <ul class="contact-inquiry-summary__list">${items}</ul>
      <p class="contact-inquiry-summary__hint">These details were added to the message below. You can edit them before submitting.</p>
    `;
  }

  function findMessageField(scope) {
    return (
      scope.querySelector('textarea[name="contact[body]"]') ||
      scope.querySelector('#ContactForm-body') ||
      scope.querySelector('textarea.contact-form__input--textarea')
    );
  }

  function run() {
    const entries = readParams();
    if (!entries.length) return;

    const wrappers = document.querySelectorAll('.contact-form');
    if (!wrappers.length) return;

    const messageText = buildMessage(entries);

    for (const wrapper of wrappers) {
      const summary = wrapper.querySelector('[data-contact-inquiry-summary]');
      if (summary) {
        summary.hidden = false;
        summary.innerHTML = buildSummaryHtml(entries);
      }

      const textarea = findMessageField(wrapper);
      if (!(textarea instanceof HTMLTextAreaElement)) continue;

      const current = textarea.value.trim();
      const looksPrefill =
        current.startsWith('Customer type:') ||
        current.includes('\nAdditional notes:');

      if (!current || looksPrefill) {
        textarea.value = messageText;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
